import { API } from '@/lib/api';

// Streams a chat message to the AI backend over SSE (cookie-authenticated).
// onDelta(text) is called for each token chunk; resolves with the full reply.
// model: 'gemini' | 'claude' (backend falls back to default when omitted)
export async function streamAiChat(message, mode, onDelta, model) {
  const res = await fetch(`${API}/ai/chat`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ message, mode, model }),
  });
  if (!res.ok || !res.body) {
    let detail = 'AI is unavailable right now.';
    try { detail = (await res.json()).detail || detail; } catch (parseErr) { detail = `${detail} (HTTP ${res.status})`; }
    throw new Error(detail);
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let full = '';
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split('\n\n');
    buffer = parts.pop();
    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith('data:')) continue;
      try {
        const evt = JSON.parse(line.slice(5).trim());
        if (evt.delta) { full += evt.delta; onDelta(evt.delta); }
        if (evt.error) throw new Error(evt.error);
        if (evt.done) return full;
      } catch (e) {
        if (e instanceof SyntaxError) continue; // partial frame
        throw e;
      }
    }
  }
  return full;
}
